import {User} from "@/interfaces/user";

export const createTestUser = (): User => {
  return {
    id: -1,
    first_name: 'Test',
    last_name: 'User',
    email: null,
    country: null,
    state: null,
    date_joined: new Date(Date.now()).toISOString(),
    last_login: new Date(Date.now()).toISOString(),

    organization_name: null,
    organization_type: null,
    primary_field: null,
    title: null,
    experience: null,
  }
}


export const createDefaultUser = (): User => {
  return {
    id: -1,
    first_name: 'Default',
    last_name: 'User',
    email: null,
    country: null,
    state: null,
    date_joined: new Date(Date.now()).toISOString(),
    last_login: new Date(Date.now()).toISOString(),

    organization_name: null,
    organization_type: null,
    primary_field: null,
    title: null,
    experience: null,
  }
}
